/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BlogueAccueil.css';
import fetch from '../../core/fetch';
import { Link } from 'react-router';
import HeightMatchingGroup from 'react-height-matching-group';

let boundItemClick = [];

@withStyles(s)
export default class BlogueAccueil extends Component{
    
    constructor(props) {
        super(props);

        this.state = {
            posts: []
        };

    }

    componentDidMount(){

        this.GetPosts();
        
    }

    async GetPosts(){
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{posts{id, slug, title, content, excerpt, thumbAccueil1, thumbAccueil2, categories{id, slug, name}, date, authorName, authorAvatar}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.posts) throw new Error('Erreur sur le chargement des posts !');

        this.setState({ posts: data.posts })

    }



    render(){
        var i = 1;
        return (
            <div className={s.root}>
                <div className={`blogAccueil bgBlue`}>
                    <div className={`container`}>
                        <span className={`titreBlogAccueil`}>Apprenez, Découvrez</span>
                        <span className={`sloganBlogAccueil`}>Comment vendre grâce au web</span>
                        <div className={`wrapBlogAccueil`}>
                            <HeightMatchingGroup tagName="ul" selector=".match">
                            {this.state.posts.slice(0, 3).map((item, index) => (
                                <li key={index} className={`col-xs-12 col-md-4`}>
                                    <div className={`articleBlog content`}>
                                        <Link to={`/blogue/${item.slug}`}>
                                            <div className={`thumbBlogAccueil`}>
                                                <img className={`largeScreen`} src={item.thumbAccueil1} alt="Image article" />
                                                <img className={`smallScreen`} src={item.thumbAccueil2} alt="Image article" />
                                            </div>
                                            <span className={`titreArticle match`} dangerouslySetInnerHTML={{ __html: item.title }} />
                                            <div className={`excerptArticle`}>
                                                <p>{item.excerpt}</p>
                                            </div>
                                        </Link>
                                        <span className={`lirePlus`}>
                                            <Link to={`/blogue/${item.slug}`}>Lire plus</Link>
                                        </span>
                                    </div>
                                </li>
                            ))}
                            </HeightMatchingGroup>
                        </div>
                    </div>
                    <div className={`wrapBlogBottomAccueil`}>
                        <div className={`container`}>
                            <div className={`col-lg-7 col-md-12`}>
                                <div className={`texteBlogBottom`}>
                                    <p>{this.props.texteBlogue}</p>
                                </div>
                            </div>
                            <div className={`col-lg-5 col-md-12`}>
                                <div className={`btnSite`}>
                                    <Link to="/blogue">{this.props.ctaBlogue}</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./components/BlogueAccueil/BlogueAccueil.js